import { render, staticRenderFns } from "./OPORepairshopListCard.vue?vue&type=template&id=0adc6999"
import script from "./OPORepairshopListCard.vue?vue&type=script&lang=js"
export * from "./OPORepairshopListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports